<ng-container *ngIf="businessHours$ | async as businessHours">
  <shrd-uic-tab-content *ngFor="let tab of tabs" [id]="tabContentIdPrefix + tab">
    <ng-container [ngSwitch]="tab">
      <shrd-pf-ft-contact-footer-content
        (goBackAction)="closeAction.emit()"
        *ngSwitchCase="contactTabType.CALL_BACK"
        [hasAction]="businessHours.open"
        [isActionEnabled]="isSubmitBtnEnabled$ | async"
        [inModal]="inModal"
        [ngClass]="{ 'd-md-none': !businessHours.open || userData.isEmployee }"
      ></shrd-pf-ft-contact-footer-content>
      <shrd-pf-ft-contact-footer-content
        (goBackAction)="closeAction.emit()"
        *ngSwitchCase="contactTabType.LIVE_CHAT"
        [hasAction]="businessHours.open"
        [isActionEnabled]="(isSubmitBtnEnabled$ | async) && (liveChatInitialized$ | async)"
        [inModal]="inModal"
        [ngClass]="{ 'd-md-none': !businessHours.open || userData.isEmployee }"
        actionLabel="common.label.button.openChat"
      ></shrd-pf-ft-contact-footer-content>
      <shrd-pf-ft-contact-footer-content
        (goBackAction)="closeAction.emit()"
        *ngSwitchCase="contactTabType.SEND_MESSAGE"
        [isActionEnabled]="isSubmitBtnEnabled$ | async"
        [inModal]="inModal"
        [ngClass]="{ 'd-md-none': userData.isEmployee }"
      ></shrd-pf-ft-contact-footer-content>
      <shrd-pf-ft-contact-footer-content
        (goBackAction)="closeAction.emit()"
        *ngSwitchCase="contactTabType.FIND_STORE"
        [actionUrl]="storesUrl"
        [inModal]="inModal"
        actionLabel="common.label.button.findStore"
        [contactTabType]="contactTabType.FIND_STORE"
      ></shrd-pf-ft-contact-footer-content>
      <shrd-pf-ft-contact-footer-content
        (goBackAction)="closeAction.emit()"
        *ngSwitchDefault
        [hasAction]="false"
        [inModal]="inModal"
        class="d-md-none"
      ></shrd-pf-ft-contact-footer-content>
    </ng-container>
  </shrd-uic-tab-content>
</ng-container>
